import React from 'react';

const logoSpanStyle = {
  paddingTop: '8px',
  paddingBottom: '8px',
  width: '100%',
  height: '100px',
  display: 'table',
  margin: '0 auto',
  backgroundColor: "white"
};
const logoImgStyle = {
  display: 'block',
  width: 'auto',
  height: '100px',
  padding: '0',
  margin: '0 auto'
};

export default (props) => {
  return (
    <div style={logoSpanStyle}>
      <img src="/img/CTL-logo-sm-vertical.png" style={logoImgStyle} alt="Calhoun Truck Lines" />
    </div>);
};


// WEBPACK FOOTER //
// ./src/components/DashboardLogoGroup/DashboardLogoGroup.js